module.exports = __webpack_public_path__ + "img/ctrl-ry-theta-1.a6c41d01.svg";